import { HttpHeaders } from '@angular/common/http';
import { environment } from '@env';

export const ApiEndpoints = {

    // change Organizations
    changeOrganizations: `${environment.apiHost}/User/change-add-organization`,
    deleteOrganization: `${environment.apiHost}/User/deleteOrganization`,
    // dashboard Applications
    getMyApplications: `${environment.apiHost}/Application`,
    getCEOApplications: `${environment.apiHost}/User/CEOApplication`,
    userApplications: `${environment.apiHost}/User/users-application?Userid=`,
    userNotifications: `${environment.apiHost}/User/NotificationScreen/`,
    // Me or My
    // ===============

    getMyOrganizations: `${environment.apiHost}/user/me/organizations`,
    getDODOrganizations: `${environment.apiHost}/user/me/DODOrganizations`,
    getUserSearchOrganizations: `${environment.apiHost}/user/me/UserSearchOrganizations`,

    // Member Search Screen APIs
    // ==================================

    getMembers: `${environment.apiHost}/user/search`,
    bulkUserRegistration: `${environment.apiHost}/User/BulkUser`,
    userRegistrationBulk: `${environment.apiHost}/User/BulkUserRegistration`,


    // Approval Queue Screen APIs
    // ==================================

    // Get Search builder params details
    searchBuilderParamsForApprovalQueue: `${environment.apiHost}/lookup/search-builder-params/by-screeen/1`,

    searchBuilderParamsForMemberSearch: `${environment.apiHost}/lookup/search-builder-params/by-screeen/0`,

    // Get Pending Approval users details
    getPendingApprovalUsers: `${environment.apiHost}/user/pending-approval`,
    // Send User Approval or Reject request
    postUserApproveOrReject: `${environment.apiHost}/user/approve-reject`,
    getMyInfo: `${environment.apiHost}/user/me`,

    // Get NotificationCount
    getNotificationCount: `${environment.apiHost}/user/NotificationIconCount`,
    //Assign application for CEO
    updateCEOAssignApplicationRole: `${environment.apiHost}/User/CEOAssignApplicationRole`,

    // Search Query builder - APIs
    // ====================================

    // Lookup APIs
    // =================

    lookupMetadata: `${environment.apiHost}/Lookup/metadata`,
    getApplicationList: `${environment.apiHost}/Application`,
    getRoleList: `${environment.apiHost}/Role`,
    getApplicationRoles: `${environment.apiHost}/Role/Getapplicationroles`,
    getApplicationAndGenericRoles: `${environment.apiHost}/Role/GetGenericAndApplicationRoles`,
    addRole: `${environment.apiHost}/Role`,
    updateRole: `${environment.apiHost}/Role`,
    deleteRole: `${environment.apiHost}/Role`,
    getAllCountries: `${environment.apiHost}/Lookup/countries`,
    verifyUserName: `${environment.apiHost}/Verification/by-username/`,
    verifyEmail: `${environment.apiHost}/Verification/send-otp-email/`,
    verifyEmailDelete: `${environment.apiHost}/Verification/send-otp-email-delete/`,
    getAllTimezones: `${environment.apiHost}/Lookup/timezones/`,
    getAllOrganizations: `${environment.apiHost}/Lookup/organizations/`,
    userRegister: `${environment.apiHost}/registration`,
    findUser: `${environment.apiHost}/registration/finduser`,
    firstTimeUser: `${environment.apiHost}/registration/useremailid/`,
    fieldValidation: `${environment.apiHost}/Verification/field-validation/`,
    getNationalStaff: `${environment.apiHost}/User/nationalstaff-users`,
    deleteUser: `${environment.apiHost}/User`,
    getManagersForOrg: `${environment.apiHost}​/Registration/Get-Organization-Users`,
    updateUserEmailId: `${environment.apiHost}/User/Change-User-EmailId/`,
    // ApplicationManagement
    appCreation: `${environment.apiHost}/Application`,
    appUpdate: `${environment.apiHost}/Application/UpdateApplication`,
    deleteApp: `${environment.apiHost}/Application?AppicationsId=`,
    roleNameValidation: `${environment.apiHost}/Role/GroupName?GroupName=`,

    // MemberProfile -> Change Password
    changePassword: `${environment.apiHost}/User/ChangePassword`,

    // RoleManagement -> Generic Roles
    roleCreation: `${environment.apiHost}/Role`,
    roleUpdate: `${environment.apiHost}/Role`,
    roleDelete: `${environment.apiHost}/Role/`,

    // MemberProfile -> Generic Roles
    userRoleAssign: `${environment.apiHost}/User/users-role-assign`,
    getUserAssignedGenericRoles: `${environment.apiHost}/User/role/`,

    // MemberProfile -> Application and Roles
    getUserAppRoleMapping: `${environment.apiHost}/User/users-applicationrole-assign/`, // Username
    userAppRoleMapping: `${environment.apiHost}/User/users-applicationrole-assign`,
    appRoleDeleteEntry: `${environment.apiHost}/User/users-applicationrole-assign/`,

    // MemberProfile -> Audit History
    getAuditHistory: `${environment.apiHost}/User/AuditLog/`,

    //Application Audit Log
    createApplicationAuditLog: `${environment.apiHost}/User/Application_AuditLog/`,

    // RoleManagement -> Application and Roles
    getPosAppRoleMapping: `${environment.apiHost}/Application/user/Position/ApplicationwithRoles`, // UserId
    posAppRoleMapping: `${environment.apiHost}/Application/PositionMapApplicationandRoles`,
    deletePosAppRoleMapping: `${environment.apiHost}/Application/user/Position/ApplicationwithRoles`,

    // RoleManagement -> Generic Role Mapping
    getGenericRoleMapping: `${environment.apiHost}/Application/GetPositionwithGenericRoles`, // UserId
    genericRoleMapping: `${environment.apiHost}/Application/AddPositionsMapWithGenericRoles`,
    deleteGenericRoleMapping: `${environment.apiHost}/Application/DeletePositionsMapWithGenericRoles`,

    getClubStateCountry: `${environment.apiHost}/Lookup/GetSites/`,
    getUserInfo: `${environment.apiHost}/User/`,
    putUserInfo: `${environment.apiHost}/User/`,
    getSupplierType: `${environment.apiHost}/User/SupplierTypeVerification/`,
    // putUserInfo: `${environment.apiHost}User/switch-organization`,
    // secondaryOrg  APIs
    // ==================================
    secondaryOrgApi: `${environment.apiHost}/User/switch-organization`,

    // update popup ignore value  for initial popup
    updatePopupIgnoreValue :`${environment.apiHost}/User/UpdatePopupIgnore?popupIgnore=`
}

// this Header will be used to identify the anonymous API Endpoint and Skip the Intercept 
export const AnonymousRequestHeaderOptions = {
    headers: new HttpHeaders({ 'Anonymous': 'yes' })
};

export const AnonymousEndPoints: string[] = [
    ApiEndpoints.lookupMetadata,
    ApiEndpoints.getAllCountries,
    ApiEndpoints.verifyEmail,
    ApiEndpoints.getAllTimezones,
    ApiEndpoints.getAllOrganizations,
    ApiEndpoints.userRegister,
    ApiEndpoints.getClubStateCountry,
    ApiEndpoints.findUser,
    ApiEndpoints.firstTimeUser
]
